export const QueryKey = {
	content: 'content',
	products: 'products',
	assets: 'assets',
	colors: 'colors',
	attributeGroups: 'attribute-groups',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
	projects: 'projects',
	presets: 'presets',
	productModules: 'product-modules',
	creatorProductModules: 'creator-product-modules',
	productModuleCollections: 'product-module-collections',
	priceGroups: 'price-groups',
	contactConfigurator: 'contact-configurator',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
